import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DatePickerModalComponent } from 'src/app/core/helper/components/date-picker-modal/date-picker-modal.component';
import { ProfileUser, UserData } from 'src/app/core/models/classes/user-data';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IListModalModel } from 'src/app/core/models/interfaces/list-modal-component-model';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { LanguageService } from 'src/app/core/services/lang.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { MediaService } from 'src/app/core/services/media.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { INewImageModel } from '../../../farm-map/models/scouting.model';
import { ProfileService } from '../../services/profile.service';
import { LocationInfoComponent } from '../location-info/location-info.component';

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss'],
})
export class ProfileDetailComponent implements OnInit {
  user: ProfileUser;
  version = "?v2=" + Math.random();
  birthDate: any;
  userInfoForm: FormGroup;
  image: INewImageModel;
  databaseError: boolean = false;
  imageUrl: string;
  constructor(private profileService: ProfileService,
    private loadingService: LoadingService,
    private storageService: StorageService,
    private constantService: DoktarConstantsService,
    private modalService: ModalService,
    private utilsService: UtilsService,
    private momentService: DateTimeService,
    private mediaService: MediaService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private langService: LanguageService) {

  }

  ngOnInit() { }

  ionViewDidEnter() {
    this.getuser();
  }

  getuser() {
    this.loadingService.showLoading();
    this.profileService.getUserDetail().subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        res.Data.PhotoUrl = res.Data.PhotoUrl;
        this.user = res.Data;
        let birthDate = this.user.UserRoleProperties.find(e => e.Key == "BirthDate")?.Value;
        let city = this.user.UserRoleProperties.find(e => e.Key == "City")?.Value;
        this.userInfoForm = new FormGroup({
          "NameSurname": new FormControl(this.user?.NameSurname, [Validators.required]),
          "UserMail": new FormControl(this.user?.Email, [Validators.required]),
          "City": new FormControl(city),
          "BirthDate": new FormControl(birthDate)
        });
        this.databaseError = false;
      } else {
        this.databaseError = true;
      }
    }, err => {
      this.databaseError = true;
      this.loadingService.hideLoading();
    });
  }

  presentCityModal() {
    this.modalService.presentModal({
      component: LocationInfoComponent,
      componentProps: {
        previousData: this.userInfoForm.controls["City"].value
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.role == "city-data") {
          this.userInfoForm.controls["City"].setValue(res.data);
        }
      });
    })
    // this.userInfoForm.controls["CityName"].setValue(city.value);
  }

  enterDate() {
    let date = new Date();
    date = new Date(this.userInfoForm.controls["BirthDate"].value);
    this.modalService.presentModal({
      component: DatePickerModalComponent,
      componentProps: {
        date: date
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.role == "date-data") {
          this.userInfoForm.controls["BirthDate"].setValue(res.data);
          // this.user.Age = res.data;
        }
      });
    });
  }

  // openPhotoOptions() {
  //   this.mediaService.openAddPhotoSheet().subscribe(
  //     (res: INewImageModel) => {
  //       if (res.image) {
  //         this.profileService.UpdateUserProfilePhoto(this.user.UserRoleId, res.src).subscribe(response => {
  //           console.log("res", res);
  //           if (response.IsSuccess) {
  //             this.user.PhotoUrl = res.src;
  //             this.toastService.PresentBasicToast({ message: this.langService.getTranslation("settings.photo-update"), duration: 3000, type: Message_Type.SUCCESS });
  //             this.storageService.get(StorageKeys.USER).then(response => {
  //               if (response.IsSuccess) {

  //               }
  //             })
  //           } else {
  //             this.toastService.PresentBasicToast({ message: this.langService.getTranslation("alert.error_on_process"), duration: 3000, type: Message_Type.DANGER })
  //           }
  //         })
  //       }
  //     }, err => {
  //     })
  // }

  save() {
    this.loadingService.showLoading();
    let userProperties = [];
    if (this.userInfoForm.value["City"]) {
      userProperties.push({
        "Key": "City",
        "Value": this.userInfoForm.value["City"],
        "Type": "text"
      })
    }
    if (this.userInfoForm.value["BirthDate"]) {
      userProperties.push({
        "Key": "BirthDate",
        "Value": this.userInfoForm.value["BirthDate"],
        "Type": "text"
      })
    }
    let newPersonalInfo = {
      NameSurname: this.userInfoForm.value["NameSurname"],
      Email: this.userInfoForm.value["UserMail"],
      UserRoleProperties: userProperties
    }

    this.profileService.UpdateUserInfos(newPersonalInfo).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.storageService.get(StorageKeys.USER).then(e => {
          if (e.IsSuccess) {
            this.getuser();
            this.toastService.PresentBasicToast({ message: this.translateService.instant("profile.success-save"), duration: 3500, type: Message_Type.SUCCESS })
            e.Data.CityId = this.userInfoForm.value["CityId"];
            e.Data.NameSurname = this.userInfoForm.value["NameSurname"];
            e.Data.UserMail = this.userInfoForm.value["UserMail"];
            this.storageService.set(StorageKeys.USER, e.Data);
          }
          this.loadingService.hideLoading();
        });
      } else {
        this.loadingService.hideLoading();
        this.toastService.PresentBasicToast({ message: this.translateService.instant("profile.save-error"), duration: 3000, type: Message_Type.DANGER });
      }
    });

    if (this.image) {
      let fileContent: FormData = new FormData();
      fileContent.append('File', this.image.image, `profil-image-${Date.now()}.${this.image.format}`);
      fileContent.append('FullName', this.userInfoForm.value["NameSurname"]);
      fileContent.append('Email', this.userInfoForm.value["UserMail"]);
      fileContent.append('UserTitle', "");
      this.loadingService.showLoading();
      this.profileService.setUserPhoto(fileContent, this.user.UserRoleId).subscribe(res => {
        if (res.IsSuccess) {
          this.storageService.get(StorageKeys.USER).then(e => {
            if (e.IsSuccess) {
              this.imageUrl = null;
              this.version = "?v2=" + Math.random();
              e.Data.ProfilePictureUrl = this.image.src;
              this.user.PhotoUrl = this.user.PhotoUrl;
              this.storageService.set(StorageKeys.USER, e.Data);
              // this.getuser();
              this.toastService.PresentBasicToast({ message: this.translateService.instant("profile.success-save"), duration: 3500, type: Message_Type.SUCCESS })
            }
          });
        }
        this.loadingService.hideLoading();
      });
    }
  }


  changePhoto() {
    this.mediaService.openAddPhotoSheet().subscribe((res: INewImageModel) => {
      this.image = res;
      // this.user.PhotoUrl = res.src;
      this.imageUrl = res.src;
    });
  }
}
